import { PublicKey, TransactionInstruction } from "@solana/web3.js";
import { ReferralProgram } from "../type";

export interface IUpdatePenaltyFeeReceiverParams {
  referralProgram: ReferralProgram;
  stakingAddress: PublicKey;
  owner: PublicKey;
  newFeeReceiver: PublicKey;
}

export async function createUpdatePenaltyFeeReceiverIx(
  params: IUpdatePenaltyFeeReceiverParams,
): Promise<TransactionInstruction> {
  const { referralProgram, stakingAddress, owner, newFeeReceiver } = params;

  return referralProgram.methods
    .updatePenaltyFeeReceiver()
    .accountsPartial({
      staking: stakingAddress,
      owner,
      newFeeReceiver,
    })
    .instruction();
}
